module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "trigger",
    staticClass: "ed-select-tipo",
    class: {
      'is-disabled': _vm.disabled,
      'is-focus': _vm.open
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "ed-select-tipo__trigger"
  }, [(_vm.multiple && _vm.selectedItems.length) ? [_vm._l((_vm.visibleTags), function(tag, i) {
    return _c('span', {
      key: i,
      staticClass: "ed-select-tipo__tag"
    }, [_vm._v("\n        " + _vm._s(tag.descricao) + "\n        "), (!_vm.disabled) ? _c('i', {
      staticClass: "fa fa-times ed-select-tipo__tag-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeTag(tag)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.hiddenCount > 0) ? _c('span', {
    staticClass: "ed-select-tipo__tag ed-select-tipo__tag--count"
  }, [_vm._v("\n        +" + _vm._s(_vm.hiddenCount) + "\n      ")]) : _vm._e()] : (!_vm.multiple && _vm.selectedLabel) ? _c('span', {
    staticClass: "ed-select-tipo__value"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedLabel) + "\n    ")]) : _c('span', {
    staticClass: "ed-select-tipo__placeholder"
  }, [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]), _vm._v(" "), (_vm.clearable && _vm.hasValue && !_vm.disabled) ? _c('i', {
    staticClass: "fa fa-times ed-select-tipo__clear",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clear($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down ed-select-tipo__arrow",
    class: {
      'is-reverse': _vm.open
    }
  })], 2), _vm._v(" "), _c('teleport-dropdown', {
    attrs: {
      "visible": _vm.open,
      "trigger-el": _vm.$refs.trigger
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.filteredItems.length > 7 || _vm.search) ? _c('div', {
    staticClass: "ed-select-tipo__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchInput",
    staticClass: "ed-select-tipo__search-input",
    attrs: {
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "optionsList",
    staticClass: "ed-select-tipo__options"
  }, [_vm._l((_vm.filteredItems), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "ed-select-tipo__option",
      class: {
        'is-selected': _vm.isSelected(item),
        'is-hover': _vm.hoverIndex === item.id
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(item)
        },
        "mouseenter": function($event) {
          _vm.hoverIndex = item.id
        }
      }
    }, [(_vm.multiple) ? _c('span', {
      staticClass: "ed-select-tipo__option-check"
    }, [_c('i', {
      class: _vm.isSelected(item) ? 'fa fa-check-square' : 'fa fa-square-o'
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ed-select-tipo__option-content"
    }, [_c('div', [_vm._v(_vm._s(item.descricao))]), _vm._v(" "), (item.obs) ? _c('div', {
      staticClass: "ed-select-tipo__option-obs"
    }, [_vm._v(_vm._s(item.obs))]) : _vm._e()])])
  }), _vm._v(" "), (_vm.filteredItems.length === 0) ? _c('div', {
    staticClass: "ed-select-tipo__empty"
  }, [_vm._v("\n        Nenhum resultado\n      ")]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c5b4f8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/EdSelectTipo.vue
// module id = 1476
// module chunks = 45